export const REDUCER_NAME = "globalSettings";

export const ACTION_TYPES = {
  getGlobalSettings: `${REDUCER_NAME}/getGlobalSettings`,
};
